"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSetPointerMessage = exports.isPointerToolSetMessage = void 0;
const isPointerToolSetMessage = (msg) => msg.messageType === 'pointer-tool-set';
exports.isPointerToolSetMessage = isPointerToolSetMessage;
const isSetPointerMessage = (msg) => msg.messageType === 'pointer-position-set';
exports.isSetPointerMessage = isSetPointerMessage;
